import axios from '@/utils/request'
var Qs = require('qs')
export default {
	// 2021-01-27
	findOwnerStore() {
		return axios.get('/adapterJuShiTa/aliexpress-stores/find-owner-store');
	},
	// 2021-01-27
	batchManualAckOrder(params) {
		return axios.get('/adapterJuShiTa/aliexpress-stores/ack-bargains?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-01-27
	findByTenantId() {
		return axios.get('/adapterJuShiTa/aliexpress-stores/find-by-tenant-id');
	},
	// 2021-01-27
	create(params) {
		return axios.post('/adapterJuShiTa/aliexpress-stores', params);
	},
	// 2021-01-27
	delete(id) {
		return axios.delete('/adapterJuShiTa/aliexpress-stores/' + id);
	},
	// 2021-01-27
	update(id, params) {
		return axios.put('/adapterJuShiTa/aliexpress-stores/' + id, params);
	},
	// 2021-01-27
	accessToken(id, params) {
		return axios.put('/adapterJuShiTa/aliexpress-stores/' + id + '/access-token', params);
	},
	// 2021-01-27
	subscribe(id, params) {
		return axios.put('/adapterJuShiTa/aliexpress-stores/' + id + '/subscribe', params);
	},
	// 2021-01-27
	clearSubscribe(id) {
		return axios.put('/adapterJuShiTa/aliexpress-stores/' + id + '/clear-subscribe');
	},
}
